/**
 * "TOTAL WAGE" MAY NOT BE LESS THAN THE WAGE IT TOTALS (audit M-08).
 *
 * The five salary fields are independent inputs, and nothing tied the total to
 * its components: HR could enter basic 2,000 + housing 1,500 under a total of
 * 3,000, and the payslip (which priced the components) and the WPS file (which
 * paid the total) then stated two different wages for one person.
 *
 * A total ABOVE the components is accepted — it is how a contract total with an
 * allowance nobody itemised arrives, and every document now shows the
 * difference as its own line. A total BELOW them cannot be read either way, so
 * it is refused at the boundary, and the money paths refuse a stored one too
 * (`readEmployeeSalary`'s `mismatch`).
 *
 * Checked only on what the payload carries: a patch that sends the total alone
 * is checked against the stored components by the money paths, not here.
 */
export interface SalaryFields {
  basicSalary?: number | null;
  housingAllowance?: number | null;
  transportAllowance?: number | null;
  otherAllowance?: number | null;
  totalSalary?: number | null;
}

export function salaryTotalAddsUp(v: SalaryFields): boolean {
  if (v.totalSalary == null) return true;
  const fils = (n: number | null | undefined): number => Math.round((n ?? 0) * 100);
  const components =
    fils(v.basicSalary) + fils(v.housingAllowance) + fils(v.transportAllowance) + fils(v.otherAllowance);
  return fils(v.totalSalary) >= components;
}

export const SALARY_TOTAL_ISSUE = {
  message:
    'Total wage is less than basic plus allowances. Correct the total or the components — a payslip and a wage file would otherwise state two different wages.',
  path: ['totalSalary'],
};
